<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Pricing Plans"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="App Pricing Plans" with-footer>
          <admin-pricing-plans-table :plans="plans"/>

          <template v-slot:header-right>
            <div>
              <no-permission-wrapper :show="!canCreatePricingPlans">
                <b-btn variant="primary" :to="{name: 'admin-pricing-plan-add'}" :disabled="!canCreatePricingPlans">New Pricing Plan</b-btn>
              </no-permission-wrapper>
            </div>
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {API_ROUTES} from "../api";
import AdminBreadcrumb from "../components/AdminBreadcrumb.vue";
import AdminPreloader from "../components/AdminPreloader.vue";
import AdminPanel from "../components/AdminPanel.vue";
import AdminPricingPlansTable from "../components/AdminPricingPlansTable.vue";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";

export default {
  name: "AdminPricingPlans",
  components: {NoPermissionWrapper, AdminPricingPlansTable, AdminPanel, AdminPreloader, AdminBreadcrumb},
  data() {
    return {
      plans: [],
      loading: true
    }
  },
  computed: {
    canCreatePricingPlans() {
      return this.$store.getters['auth/hasAdminPermissions']('pricing_plan_create');
    }
  },
  created() {
    this.$api.get(API_ROUTES.ADMIN_PRICING_PLANS).then(({data}) => {
      this.plans = data.pricing_plans;
    }).catch(({response}) => {
      this.$bvToast.toast('Failed to load pricing plans', {
        title: 'Error!',
        variant: 'danger'
      });
    }).finally(() => {
      this.loading = false;
    })
  }
}
</script>
